import { useQuery } from '@tanstack/react-query';

import { contactsApi } from '../../../features/contacts/api';
import { craftEmailQueryKeys } from '../../../features/craft-email-agent/queryKeys';

export const useRecipientContacts = (domain?: string, searchText = '', enabled = true) => {
  return useQuery({
    queryKey: craftEmailQueryKeys.contacts(domain, searchText),
    queryFn: () =>
      contactsApi.getContacts({
        domain,
        searchText,
        perPage: 6,
        contactDetails: {},
        status: {},
      }),
    enabled: !!domain && enabled,
  });
};
